import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/feature/details/feature.details.languages.query.gql"
import type {
  FeatureDetailsLanguagesQuery,
  FeatureDetailsLanguagesQueryVariables,
} from "@/v2-backoffice-client/feature/details/__types__/feature.details.languages.query"

type Options = QueryHookOptions<
  FeatureDetailsLanguagesQuery,
  FeatureDetailsLanguagesQueryVariables
>

export function useFeatureDetailsLanguagesQuery(options?: Options) {
  return useQuery<
    FeatureDetailsLanguagesQuery,
    FeatureDetailsLanguagesQueryVariables
  >(query, options)
}
